import { useEffect } from 'react';
import { ArrowRight } from 'lucide-react';

// ═══════════════════════════════════════════
// PRIVACY POLICY PAGE
// ═══════════════════════════════════════════

export const PrivacyPolicy = ({ onClose }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF7F2] py-20 px-4 md:px-8" dir="rtl">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={onClose}
          className="flex items-center gap-2 text-[#C4956A] hover:text-[#b38559] mb-8 transition-colors"
        >
          <ArrowRight className="w-5 h-5" />
          חזרה לאתר
        </button>

        <h1 className="font-['Heebo'] text-3xl md:text-4xl font-bold text-[#2C2C2C] mb-4">
          מדיניות פרטיות
        </h1>
        <p className="text-[#2C2C2C]/60 mb-8">עדכון אחרון: פברואר 2026</p>

        <div className="bg-white rounded-2xl p-8 shadow-sm space-y-8 text-[#2C2C2C]/80 leading-relaxed">
          
          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">א. מי אנחנו</h2>
            <p>
              אתר זה מופעל על ידי מזל, מומחית פרא-רפואית לטיפול בצלקות מורכבות.<br/>
              <strong>כתובת:</strong> חיים גבריהו 11, פסגת זאב, ירושלים<br/>
              <strong>טלפון:</strong> 052-3824500<br/>
              <strong>דוא"ל:</strong> Mazal41400@gmail.com
            </p>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ב. אילו מידע אנו אוספים</h2>
            <ul className="list-disc list-inside space-y-2 mr-4">
              <li><strong>מידע שאתם מוסרים:</strong> שם מלא, מספר טלפון, והודעה שהועברה בטופס יצירת קשר, שאלון צלקות או טופס ייעוץ</li>
              <li><strong>נתוני גלישה:</strong> מידע טכני כגון סוג הדפדפן, מערכת הפעלה, עמודים שנצפו, עיר ומכשיר (באמצעות Google Analytics 4, רק לאחר הסכמה)</li>
              <li><strong>נתוני אימות אבטחה:</strong> ציון reCAPTCHA לצורך הגנה מפני בוטים (לא נשמר, לצורך אימות בלבד)</li>
              <li><strong>שיחות יועץ AI:</strong> הודעות שנשלחות ליועץ העסקי (צ'אט AI) מעובדות על ידי שירות צד שלישי (Anthropic Claude) ואינן נשמרות לאחר סיום השיחה</li>
              <li><strong>קבצי Cookie:</strong> עוגיות הכרחיות לתפעול האתר ועוגיות ניתוח (ראו מדיניות עוגיות)</li>
            </ul>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ג. מטרת איסוף המידע</h2>
            <p>המידע נאסף אך ורק לצורך:</p>
            <ul className="list-disc list-inside space-y-2 mr-4 mt-2">
              <li>מתן מענה לפניות שלכם</li>
              <li>יצירת קשר לצורך תיאום ייעוץ או טיפול</li>
              <li>שיפור חווית הגלישה באתר</li>
            </ul>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ד. העברת מידע לצד שלישי (ספקי עיבוד)</h2>
            <p>
              איננו מוכרים, משכירים או מעבירים את המידע האישי שלכם לצדדים שלישיים למטרות שיווק.
              לצורך הפעלת האתר אנו נעזרים בספקי שירות מאובטחים הבאים, אשר עשויים לעבד מידע מטעמנו:
            </p>
            <ul className="list-disc list-inside space-y-2 mr-4 mt-2">
              <li><strong>Emergent Agent Platform</strong> — תשתית, אירוח ו-CDN (שרתים בענן). מידע: כתובות IP, נתוני בקשה.</li>
              <li><strong>MongoDB Atlas</strong> — מסד נתונים שבו נשמרים פרטי פניות ושאלונים. נתונים מוצפנים במנוחה (encryption at rest).</li>
              <li><strong>Google reCAPTCHA v3</strong> (Google LLC) — הגנה מפני בוטים בטפסים. מקבל בקשת אימות אנונימית, מוסר ציון סיכון בלבד.</li>
              <li><strong>Google Analytics 4</strong> (Google LLC) — סטטיסטיקות גלישה (נטען אך ורק לאחר הסכמתכם בבאנר עוגיות). כתובות IP מטושטשות.</li>
              <li><strong>Anthropic Claude</strong> (Anthropic PBC) — מודל AI שמעבד הודעות הצ'אט של היועצת הווירטואלית. ההודעות אינן נשמרות לאחר סיום השיחה.</li>
              <li><strong>חובה חוקית:</strong> רק במקרה של צו שיפוטי או דרישה חוקית מוסמכת.</li>
            </ul>
            <p className="mt-3 text-sm text-[#2C2C2C]/60">
              ספקים אלו פועלים בהתאם לתקני אבטחת מידע מקובלים (SOC 2, ISO 27001) ובכפוף לתנאיהם המפורסמים.
            </p>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ה. משך שמירת המידע</h2>
            <p>
              פרטי הפניות נשמרים למשך עד 3 שנים או עד למחיקה לפי בקשתכם, המוקדם מביניהם.
            </p>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ו. זכויותיכם (חוק הגנת הפרטיות ותיקון 13)</h2>
            <p>בהתאם לחוק הגנת הפרטיות, תשמ"א-1981, ולתיקון 13 (אוגוסט 2025), עומדות לכם הזכויות הבאות:</p>
            <ul className="list-disc list-inside space-y-2 mr-4 mt-2">
              <li><strong>זכות עיון:</strong> לעיין במידע השמור אודותיכם (סעיף 13 לחוק)</li>
              <li><strong>זכות תיקון:</strong> לבקש תיקון מידע שגוי או לא מדויק</li>
              <li><strong>זכות מחיקה:</strong> לבקש מחיקת המידע שלכם ("הזכות להישכח")</li>
              <li><strong>זכות לקבלת עותק:</strong> לקבל עותק של המידע השמור אודותיכם בפורמט נגיש</li>
              <li><strong>זכות התנגדות:</strong> להתנגד לעיבוד או להסתייגות לשימושים מסוימים</li>
            </ul>
            <p className="mt-4">
              <strong>כיצד לממש את זכויותיכם:</strong>
            </p>
            <ul className="list-disc list-inside space-y-2 mr-4 mt-2">
              <li>שלחו דוא"ל אל <a href="mailto:Mazal41400@gmail.com" className="text-[#C4956A] hover:underline">Mazal41400@gmail.com</a> עם נושא "בקשת זכויות פרטיות"</li>
              <li>או פנו טלפונית אל 052-3824500</li>
              <li>אנא ציינו את שמכם המלא, מספר הטלפון ששימש לפנייה, ופירוט הבקשה</li>
            </ul>
            <p className="mt-3">
              <strong>זמן טיפול:</strong> נשיב לפנייתכם תוך 30 ימים מקבלתה. במקרים מורכבים, נעדכן אתכם על הצורך בהארכה.
            </p>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ז. דיוור פרסומי וזכות ההסרה</h2>
            <p>
              בהתאם לסעיף 30א לחוק התקשורת (בזק ושידורים), תשמ"ב-1982, אנו שולחים תוכן פרסומי
              (SMS, דוא"ל, WhatsApp) <strong>אך ורק לאחר קבלת הסכמתכם המפורשת מראש</strong> באמצעות סימון תיבה ייעודית בטופס.
            </p>
            <ul className="list-disc list-inside space-y-2 mr-4 mt-2">
              <li><strong>זכות הסרה:</strong> ניתן להסיר עצמכם מרשימת התפוצה בכל עת — באמצעות לחיצה על "הסר" בהודעה, השבה במסרון בודד "הסר", או פנייה לטלפון/דוא"ל המצוין למטה.</li>
              <li><strong>פנייה ראשונית:</strong> מענה לפנייה שיזמתם (טופס יצירת קשר, שאלון) אינו מהווה דיוור פרסומי.</li>
              <li><strong>זמן טיפול בבקשת הסרה:</strong> עד 48 שעות מקבלת הבקשה.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ח. אבטחת מידע</h2>
            <p>
              אנו נוקטים באמצעי אבטחה מתקדמים להגנה על המידע שלכם, כולל:
            </p>
            <ul className="list-disc list-inside space-y-2 mr-4 mt-2">
              <li>הצפנת תקשורת (HTTPS/SSL) בכל הדפים</li>
              <li>הגבלת גישה למידע לגורמים מורשים בלבד באמצעות אימות JWT מוצפן</li>
              <li>סינון ואימות קלט בכל הטפסים (סינון HTML, אימות טלפון ושם)</li>
              <li>הגנה מפני התקפות אוטומטיות (Google reCAPTCHA v3, הגבלת קצב בקשות, שדות Honeypot)</li>
              <li>כותרות אבטחה (CSP, X-Frame-Options, X-Content-Type-Options)</li>
              <li>הצפנת סיסמאות באלגוריתם bcrypt</li>
              <li>הגנה מפני התקפות CSRF ו-XSS</li>
            </ul>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ט. שימוש בעוגיות</h2>
            <p>
              לפרטים מלאים על השימוש בעוגיות באתר, ראו את <button onClick={() => onClose('cookies')} className="text-[#C4956A] hover:underline">מדיניות העוגיות</button> שלנו.
            </p>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">י. עדכונים למדיניות</h2>
            <p>
              אנו שומרים לעצמנו את הזכות לעדכן מדיניות זו מעת לעת. תאריך העדכון האחרון מופיע בראש הדף.
              המשך השימוש באתר לאחר עדכון מהווה הסכמה למדיניות המעודכנת.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

// ═══════════════════════════════════════════
// TERMS OF USE PAGE
// ═══════════════════════════════════════════

export const TermsOfUse = ({ onClose }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF7F2] py-20 px-4 md:px-8" dir="rtl">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={onClose}
          className="flex items-center gap-2 text-[#C4956A] hover:text-[#b38559] mb-8 transition-colors"
        >
          <ArrowRight className="w-5 h-5" />
          חזרה לאתר
        </button>

        <h1 className="font-['Heebo'] text-3xl md:text-4xl font-bold text-[#2C2C2C] mb-4">
          תנאי שימוש
        </h1>
        <p className="text-[#2C2C2C]/60 mb-8">עדכון אחרון: פברואר 2026</p>

        <div className="bg-white rounded-2xl p-8 shadow-sm space-y-8 text-[#2C2C2C]/80 leading-relaxed">
          
          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">א. הסכמה לתנאים</h2>
            <p>
              השימוש באתר זה מהווה הסכמה מלאה ובלתי מסויגת לתנאי השימוש המפורטים להלן.
              אם אינכם מסכימים לתנאים אלה, אנא הימנעו משימוש באתר.
            </p>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ב. מידע כללי בלבד</h2>
            <div className="bg-[#FEF3E7] border-r-4 border-[#C4956A] p-4 rounded-lg">
              <p className="font-semibold text-[#2C2C2C]">
                המידע באתר זה הוא לצורכי מידע כללי בלבד ואינו מהווה תחליף לייעוץ רפואי מקצועי, אבחון או טיפול.
                יש להתייעץ עם רופא מוסמך לפני כל החלטה רפואית.
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ג. הגבלת אחריות</h2>
            <p>
              בעל האתר ו/או מי מטעמו אינם אחראים לכל נזק, ישיר או עקיף, שייגרם כתוצאה מ:
            </p>
            <ul className="list-disc list-inside space-y-2 mr-4 mt-2">
              <li>שימוש במידע המופיע באתר</li>
              <li>שגיאות או השמטות בתוכן האתר</li>
              <li>חוסר זמינות של האתר</li>
              <li>פעולות של צדדים שלישיים</li>
            </ul>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ד. קניין רוחני</h2>
            <p>
              כל התכנים באתר, לרבות טקסטים, תמונות, עיצוב, לוגו וסימני מסחר, הם קניינו הבלעדי של בעל האתר
              ומוגנים על פי חוקי זכויות יוצרים וקניין רוחני.
            </p>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ה. איסור העתקה</h2>
            <p>
              אין להעתיק, לשכפל, להפיץ, לפרסם או לעשות כל שימוש מסחרי בתכני האתר ללא אישור מראש ובכתב מבעל האתר.
            </p>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ו. סמכות שיפוט</h2>
            <p>
              לבתי המשפט המוסמכים בירושלים, ישראל, תהא סמכות שיפוט בלעדית בכל עניין הנוגע לשימוש באתר ולתנאי שימוש אלה.
            </p>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ז. הדין החל</h2>
            <p>
              על תנאי שימוש אלה ועל השימוש באתר יחולו אך ורק דיני מדינת ישראל.
            </p>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ח. יצירת קשר</h2>
            <p>
              לכל שאלה בנוגע לתנאי השימוש, ניתן לפנות אלינו:<br/>
              <strong>דוא"ל:</strong> Mazal41400@gmail.com<br/>
              <strong>טלפון:</strong> 052-3824500
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

// ═══════════════════════════════════════════
// COOKIE POLICY PAGE
// ═══════════════════════════════════════════

export const CookiePolicy = ({ onClose }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF7F2] py-20 px-4 md:px-8" dir="rtl">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={onClose}
          className="flex items-center gap-2 text-[#C4956A] hover:text-[#b38559] mb-8 transition-colors"
        >
          <ArrowRight className="w-5 h-5" />
          חזרה לאתר
        </button>

        <h1 className="font-['Heebo'] text-3xl md:text-4xl font-bold text-[#2C2C2C] mb-4">
          מדיניות עוגיות (Cookies)
        </h1>
        <p className="text-[#2C2C2C]/60 mb-8">עדכון אחרון: פברואר 2026</p>

        <div className="bg-white rounded-2xl p-8 shadow-sm space-y-8 text-[#2C2C2C]/80 leading-relaxed">
          
          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">מהן עוגיות?</h2>
            <p>
              עוגיות (Cookies) הן קבצי טקסט קטנים שנשמרים במחשב או במכשיר הנייד שלכם בעת ביקור באתר.
              הן משמשות לשיפור חווית הגלישה ולאיסוף מידע על אופן השימוש באתר.
            </p>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">סוגי העוגיות בשימוש</h2>
            
            <div className="overflow-x-auto">
              <table className="w-full border-collapse mt-4">
                <thead>
                  <tr className="bg-[#FAF7F2]">
                    <th className="border border-[#E5E0DA] p-3 text-right font-bold">שם</th>
                    <th className="border border-[#E5E0DA] p-3 text-right font-bold">סוג</th>
                    <th className="border border-[#E5E0DA] p-3 text-right font-bold">מטרה</th>
                    <th className="border border-[#E5E0DA] p-3 text-right font-bold">משך</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-[#E5E0DA] p-3">cookieConsent</td>
                    <td className="border border-[#E5E0DA] p-3">הכרחית</td>
                    <td className="border border-[#E5E0DA] p-3">שמירת העדפות העוגיות שלכם</td>
                    <td className="border border-[#E5E0DA] p-3">שנה</td>
                  </tr>
                  <tr>
                    <td className="border border-[#E5E0DA] p-3">exitPopupDismissed</td>
                    <td className="border border-[#E5E0DA] p-3">הכרחית</td>
                    <td className="border border-[#E5E0DA] p-3">מניעת הצגה חוזרת של חלון קופץ</td>
                    <td className="border border-[#E5E0DA] p-3">סשן</td>
                  </tr>
                  <tr>
                    <td className="border border-[#E5E0DA] p-3">_ga, _gid</td>
                    <td className="border border-[#E5E0DA] p-3">ניתוח</td>
                    <td className="border border-[#E5E0DA] p-3">Google Analytics 4 (G-KNWJCERH7H) - ניתוח תנועה באתר, מיקומים ומכשירים</td>
                    <td className="border border-[#E5E0DA] p-3">עד שנתיים</td>
                  </tr>
                  <tr>
                    <td className="border border-[#E5E0DA] p-3">_GRECAPTCHA</td>
                    <td className="border border-[#E5E0DA] p-3">אבטחה</td>
                    <td className="border border-[#E5E0DA] p-3">Google reCAPTCHA v3 - הגנה מפני בוטים וספאם בטפסים</td>
                    <td className="border border-[#E5E0DA] p-3">6 חודשים</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">עוגיות הכרחיות</h2>
            <p>
              עוגיות אלו חיוניות לתפעול התקין של האתר ואינן דורשות הסכמה. הן משמשות לשמירת העדפות בסיסיות.
            </p>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">עוגיות ניתוח</h2>
            <p>
              עוגיות אלו (כגון Google Analytics 4) נטענות רק לאחר שתאשרו זאת בבאנר העוגיות.
              הן מסייעות לנו להבין כיצד מבקרים משתמשים באתר ולשפר את השירות.
              כתובות IP מוסתרות (anonymized) ואיננו אוספים מידע מזהה אישית.
            </p>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">עוגיות אבטחה</h2>
            <p>
              עוגיות reCAPTCHA של Google משמשות להגנה על טפסי האתר מפני בוטים וספאם.
              עוגיות אלו הכרחיות לאבטחת האתר ואינן דורשות הסכמה נפרדת.
              המידע הנאסף משמש רק לאימות שהמבקר הוא אדם ולא בוט.
            </p>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ניהול עוגיות בדפדפן</h2>
            <p>
              ניתן לנהל או למחוק עוגיות באמצעות הגדרות הדפדפן שלכם:
            </p>
            <ul className="list-disc list-inside space-y-2 mr-4 mt-2">
              <li><strong>Chrome:</strong> הגדרות → פרטיות ואבטחה → עוגיות</li>
              <li><strong>Firefox:</strong> הגדרות → פרטיות ואבטחה → עוגיות ונתוני אתרים</li>
              <li><strong>Safari:</strong> העדפות → פרטיות → ניהול נתוני אתרים</li>
              <li><strong>Edge:</strong> הגדרות → פרטיות, חיפוש ושירותים → עוגיות</li>
            </ul>
            <p className="mt-4 text-sm">
              שימו לב: חסימת עוגיות עלולה לפגוע בחלק מהפונקציונליות של האתר.
            </p>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">יצירת קשר</h2>
            <p>
              לשאלות בנוגע לעוגיות, פנו אלינו בדוא"ל: Mazal41400@gmail.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

// ═══════════════════════════════════════════
// ACCESSIBILITY STATEMENT PAGE
// ═══════════════════════════════════════════

export const AccessibilityStatement = ({ onClose }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF7F2] py-20 px-4 md:px-8" dir="rtl">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={onClose}
          className="flex items-center gap-2 text-[#C4956A] hover:text-[#b38559] mb-8 transition-colors"
        >
          <ArrowRight className="w-5 h-5" />
          חזרה לאתר
        </button>

        <h1 className="font-['Heebo'] text-3xl md:text-4xl font-bold text-[#2C2C2C] mb-4">
          הצהרת נגישות
        </h1>
        <p className="text-[#2C2C2C]/60 mb-8">עדכון אחרון: פברואר 2026</p>

        <div className="bg-white rounded-2xl p-8 shadow-sm space-y-8 text-[#2C2C2C]/80 leading-relaxed">
          
          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">א. מחויבותנו לנגישות</h2>
            <p>
              אנו מחויבים להנגשת האתר לאנשים עם מוגבלויות, בהתאם לחוק שוויון זכויות לאנשים עם מוגבלות, 
              תשנ"ח-1998, ותקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות), תשע"ג-2013,
              ובהתאם לתקן הישראלי ת"י 5568 ולהנחיות WCAG 2.1 ברמה AA.
            </p>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ב. רמת הנגישות</h2>
            <p>
              האתר עומד ברמת נגישות AA בהתאם להנחיות WCAG 2.1 ולתקן הישראלי 5568.
            </p>
            <p className="mt-2">
              <strong>תאריך סקירת נגישות אחרונה:</strong> פברואר 2026
            </p>
            <p className="mt-1 text-sm text-[#2C2C2C]/60">
              סקירת הנגישות בוצעה באמצעות שילוב של כלים אוטומטיים (Lighthouse, axe DevTools) ובדיקה ידנית של ניווט במקלדת, קוראי מסך וניגודיות. אנו פועלים באופן שוטף לעמידה בתקן הישראלי ת"י 5568 ובהנחיות WCAG 2.1 ברמה AA.
            </p>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ג. מה עשינו להנגשת האתר</h2>
            <ul className="list-disc list-inside space-y-2 mr-4">
              <li>התאמה לגלישה באמצעות מקלדת בלבד</li>
              <li>שימוש בתגיות HTML סמנטיות</li>
              <li>טקסטים חלופיים (alt) לתמונות</li>
              <li>ניגודיות צבעים מספקת</li>
              <li>מבנה כותרות היררכי נכון</li>
              <li>תוויות לשדות טפסים</li>
              <li>קישור "דלג לתוכן" בראש העמוד</li>
              <li>אפשרות להגדלת טקסט</li>
              <li>תמיכה בקורא מסך</li>
              <li>התאמה לתצוגה בגדלי מסך שונים</li>
            </ul>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ד. רכיבים שאינם נגישים במלואם</h2>
            <p>
              ייתכן כי חלק מהתוכן באתר אינו נגיש במלואו. אנו עובדים באופן מתמיד לשיפור הנגישות.
              להלן רכיבים שנמצאים בתהליך הנגשה:
            </p>
            <ul className="list-disc list-inside space-y-2 mr-4 mt-2">
              <li>תמונות מסוימות מבנקי תמונות חיצוניים</li>
              <li>אנימציות מורכבות (ניתן לעצור באמצעות כלי הנגישות)</li>
            </ul>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ה. פרטי רכז/ת הנגישות</h2>
            <p>
              <strong>שם:</strong> מזל<br/>
              <strong>טלפון:</strong> 052-3824500<br/>
              <strong>דוא"ל:</strong> Mazal41400@gmail.com
            </p>
          </section>

          <section>
            <h2 className="font-['Heebo'] text-xl font-bold text-[#2C2C2C] mb-4">ו. דיווח על בעיית נגישות</h2>
            <p>
              נתקלתם בבעיית נגישות באתר? נשמח לשמוע ולטפל בהקדם.
              אנא פנו אלינו באחת הדרכים הבאות:
            </p>
            <ul className="list-disc list-inside space-y-2 mr-4 mt-2">
              <li><strong>טלפון:</strong> 052-3824500</li>
              <li><strong>דוא"ל:</strong> Mazal41400@gmail.com</li>
              <li><strong>טופס יצירת קשר:</strong> באתר</li>
            </ul>
            <p className="mt-4">
              אנא פרטו את הבעיה שנתקלתם בה, את הדף שבו היא מופיעה, ופרטי התקשרות לחזרה.
              נשתדל לטפל בפניות נגישות תוך 14 ימי עבודה.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default { PrivacyPolicy, TermsOfUse, CookiePolicy, AccessibilityStatement };
